'use client';

import { motion, useScroll, useMotionValueEvent } from 'motion/react';
import { ReactNode, useState } from 'react';

import { DEFAULT_EASE } from '@natu/utils/consts';

const headerVariants = {
  visible: { y: 0 },
  hidden: { y: '-100%' },
};

interface HeaderProps {
  children: ReactNode;
  className?: string;
}

export const Header = ({ children, className }: HeaderProps) => {
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);

  useMotionValueEvent(scrollY, 'change', latest => {
    const previous = scrollY.getPrevious();
    if (previous && latest > previous && latest > 150) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  });

  return (
    <motion.header
      variants={headerVariants}
      animate={hidden ? 'hidden' : 'visible'}
      transition={{ ease: DEFAULT_EASE, duration: 0.6 }}
      className={className}
    >
      {children}
    </motion.header>
  );
};
